
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-wins",
      function () {
        return require("private-next-pages/my-wins/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-wins"])
      });
    }
  